import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import Icon from 'components/Icon';

import styles from './styles.module.scss';

const ButtonAction = ({ icon, title, type, active, onClick }) => {
	const buttonCx = cx(styles.button, styles[`type_${type}`], {
		[styles.active]: active
	});

	return (
		<button className={buttonCx} title={title} type="button" onClick={onClick}>
			<Icon icon={icon} className={cx(styles.icon, styles[icon])} />
		</button>
	);
};

ButtonAction.propTypes = {
	onClick: PropTypes.func,
	icon: PropTypes.string.isRequired,
	title: PropTypes.string.isRequired,
	type: PropTypes.string,
	active: PropTypes.bool
};
ButtonAction.defaultProps = {
	active: false
};

export default ButtonAction;
